/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reps: NonNullable<unknown> }} Workout_Detail_RepsInputs */

const en_us2_workout_detail_reps = /** @type {(inputs: Workout_Detail_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 rep`);
	return /** @type {LocalizedString} */ (`${i?.reps} reps`)
	
};

const pt_br2_workout_detail_reps = /** @type {(inputs: Workout_Detail_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetição`);
	return /** @type {LocalizedString} */ (`${i?.reps} repetições`)
	
};

const es_419_workout_detail_reps = /** @type {(inputs: Workout_Detail_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 rep`);
	return /** @type {LocalizedString} */ (`${i?.reps} reps`)
	
};

const pt_pt2_workout_detail_reps = /** @type {(inputs: Workout_Detail_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetição`);
	return /** @type {LocalizedString} */ (`${i?.reps} repetições`)
	
};

const fr_fr2_workout_detail_reps = /** @type {(inputs: Workout_Detail_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 répétition`);
	return /** @type {LocalizedString} */ (`${i?.reps} répétitions`)
	
};

const de_de2_workout_detail_reps = /** @type {(inputs: Workout_Detail_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 Wdh.`);
	return /** @type {LocalizedString} */ (`${i?.reps} Wdh.`)
	
};

const it_it2_workout_detail_reps = /** @type {(inputs: Workout_Detail_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 ripetizione`);
	return /** @type {LocalizedString} */ (`${i?.reps} ripetizioni`)
	
};

/**
* | reps | output |
* | --- | --- |
* | "1" | "1 rep" |
* | * | "{reps} reps" |
*
* @param {Workout_Detail_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_detail_reps = /** @type {((inputs: Workout_Detail_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Detail_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_detail_reps(inputs)
	if (locale === "es-419") return es_419_workout_detail_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_detail_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_detail_reps(inputs)
	if (locale === "de-DE") return de_de2_workout_detail_reps(inputs)
	if (locale === "it-IT") return it_it2_workout_detail_reps(inputs)
	return en_us2_workout_detail_reps(inputs)
});
export { workout_detail_reps as "workout.detail_reps" }